import React, { Component } from "react";

import PropTypes from "prop-types";

import { bytesToReadable } from "../../../Utility/utility";

import {
  TrashIcon,
  AttachmentIcon,
  WrongCircleIcon,
  SuccessCircleIcon,
  FileTypePDFIcon,
  FileTypeBMPIcon,
  FileTypeJPEGIcon,
  FileTypeTIFFIcon,
  FileTypeXFDLIcon,
} from "../../Common/Svg";

import ExitConfirmation from "./../../Common/ExitConfirmation/ExitConfirmation";

import { GreenButton } from "./../../../StyledComponents";

import { getFileNameWithoutExtension } from "./../../../Utility/utility";

import "./FileAttachment.css";

const StepTypes = {
  Idle: "idle",
  Completed: "completed",
  Processing: "processing",
};

const FileTypes = {
  "image/tiff": {
    name: "TIF/TIFF",
    icon: FileTypeTIFFIcon,
  },
  "image/jpeg": {
    name: "JPG/JPEG",
    icon: FileTypeJPEGIcon,
  },
  "application/pdf": {
    name: "PDF",
    icon: FileTypePDFIcon,
  },
  dmp: {
    name: "DMP",
    icon: FileTypeBMPIcon,
  },
  xfdl: {
    name: "XFDL",
    icon: FileTypeXFDLIcon,
  },
  "image/bmp": {
    name: "BMP",
    icon: FileTypeBMPIcon,
  },
};

const ProcessBar = ({ percentageValue = 0 }) => (
  <div className="process-bar">
    <div
      className="indicator"
      style={{
        width: `${percentageValue}%`,
      }}
    />
  </div>
);

export class FileAttachment extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {
    file: {
      icon: null,
      type: null,
      size: null,
      name: null,
      fileObj: null,
    },
    processValue: 0,
    hasError: false,
    errorMessage: null,
    step: StepTypes.Idle,
    fileDeleteConfirmation: false,
  };

  inputRef = null;
  maxFileSize = 4194304;
  uploadOrProcessMockingSetIntervalRef = null;
  emptyFile = {
    icon: null,
    type: null,
    size: null,
    name: null,
    fileObj: null,
  };

  componentDidMount = () => {
    if (this.props.fileObj) {
      const { name, type, size } = this.props.fileObj;
      const fileTypeInfo = this.getFileTypeInfo(type, name);

      const fileData = {
        name: name,
        size: size,
        type: type,
        icon: fileTypeInfo && fileTypeInfo.icon,
        fileObj: this.props.fileObj,
      };

      this.setState({
        file: fileData,
        hasError: false,
        errorMessage: null,
        step: StepTypes.Completed,
      });
    }
  };

  uploadOrProcessMocking = (file) => {
    this.uploadOrProcessMockingSetIntervalRef = setInterval(() => {
      if (this.state.processValue === 100 || this.state.processValue > 100) {
        clearInterval(this.uploadOrProcessMockingSetIntervalRef);

        this.setState({
          step: StepTypes.Completed,
        });

        this.props.onChange(file.fileObj);

        return;
      }

      this.setState({
        processValue: this.state.processValue + 5,
      });
    }, 50);
  };

  renameFile = (originalFile, newName) => {

    return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
    });
  }

  onInputFileChange = (file) => {
    if (!file) {
      return;
    }

    const { name, type, size } = file;
    const fileNameWithoutExtension = getFileNameWithoutExtension(name);

    if (size > this.maxFileSize) {
      this.setState({
        hasError: true,
        errorMessage: `Make sure that your files are smaller than ${bytesToReadable(
          this.maxFileSize
        )}`,
      });
      return;
    }

    let fileTypeInfo = null;

    if (!(fileTypeInfo = this.getFileTypeInfo(type, name))) {
      this.setState({
        hasError: true,
        errorMessage: "File formats allowed: pdf, xfdl, jpeg, tiff, jpg or bmp",
      });
      return;
    }

    if (
      this.props.currentFileNames.find((e) => e === fileNameWithoutExtension)
    ) {
      this.setState({
        hasError: true,
        errorMessage: "File is already selected.",
      });
      return;
    }

    const fileExt = name.split('.').slice(-1)[0];

    const fileData = {
      name: `${this.props.file}.${fileExt}`,
      size: size,
      type: type,
      icon: fileTypeInfo?.icon,
      fileObj: this.renameFile(file, `${this.props.file}.${fileExt}`),
    };

    this.setState(
      {
        file: fileData,
        hasError: false,
        errorMessage: null,
        step: StepTypes.Processing,
      },
      () => {
        this.uploadOrProcessMocking(fileData);
      }
    );
  };

  handleAttachFile = () => {
    this.setState({
      file: this.emptyFile,
    });

    !!this.inputRef?.click && this.inputRef.click();
  };

  handleDeleteFile = () => {
    this.setState({
      fileDeleteConfirmation: true,
    });
  };

  handleProcessCancel = () => {
    clearInterval(this.uploadOrProcessMockingSetIntervalRef);

    this.setState({
      hasError: false,
      processValue: 0,
      errorMessage: null,
      step: StepTypes.Idle,
      file: this.emptyFile,
    });

    this.props.onChange(null);
  };

  getFileTypeInfo = (fileType, fileName = null) => {
    const getFileExtensionViaName = (name) => {
      if (typeof name !== "string") {
        return null;
      }

      return name.split(".").pop();
    };

    return FileTypes[fileType || getFileExtensionViaName(fileName)];
  };

  getIdleRender = () => {
    return (
      <div className="idle">
        <span>{this.props.title}</span>
        <input
          type="file"
          ref={(ref) => (this.inputRef = ref)}
          onChange={(e) => this.onInputFileChange(e.target.files[0])}
        />
        <GreenButton onClick={this.handleAttachFile}>
          <AttachmentIcon />
          Attach
        </GreenButton>
      </div>
    );
  };

  getProcessingRender = () => {
    const { file, processValue } = this.state;

    return (
      <div className="processing">
        {/* {!!file.icon && <file.icon />} */}

        <div className="file-details" style={{ padding: 0 }}>
          <div className="details">
            <div className="name">{file?.name}</div>

            <div className="process-value">{`${processValue}%`}</div>
          </div>

          <div className="process-bar-container">
            <ProcessBar percentageValue={processValue} />
          </div>
        </div>

        <div
          title="Cancel"
          className="button"
          onClick={this.handleProcessCancel}
        >
          <WrongCircleIcon />
        </div>
      </div>
    );
  };

  getCompletedRender = () => {
    const { file } = this.state;

    return (
      <div className="completed">
        {!!file.icon && <file.icon />}

        <div className="file-details">
          <div className="name">{file?.name}</div>

          <div className="size">{bytesToReadable(file?.size)}</div>
        </div>

        <SuccessCircleIcon
          size={35}
          className="file-attachment__complete-icons"
        />

        <TrashIcon
          size={35}
          className="file-attachment__complete-icons"
          onClick={this.handleDeleteFile}
          style={{
            cursor: "pointer",
          }}
        />
      </div>
    );
  };

  removeFileCancelHandler = () => {
    this.setState({
      fileDeleteConfirmation: false,
    });
  };

  removeFileOkayHandler = () => {
    this.setState({
      hasError: false,
      processValue: 0,
      errorMessage: null,
      step: StepTypes.Idle,
      file: this.emptyFile,
      fileDeleteConfirmation: false,
    });
    this.props.onChange(null);
  };

  getStepRender = (step) => {
    switch (step) {
      case StepTypes.Idle:
        return this.getIdleRender();

      case StepTypes.Processing:
        return this.getProcessingRender();

      case StepTypes.Completed:
        return this.getCompletedRender();

      default:
        return null;
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.uploadOrProcessMockingSetIntervalRef);
  };

  render = () => {
    const { step, hasError, errorMessage } = this.state;

    return (
      <div className="file-attachment-container">
        <div className={`file-attachment ${(hasError && "error") || ""}`}>
          {this.getStepRender(this.state.step)}
        </div>

        {hasError && (
          <div className="error-message">
            <WrongCircleIcon
              size={16}
              color={"#BD0000"}
              style={{
                marginRight: "5px",
              }}
            />

            {errorMessage}
          </div>
        )}
        {this.state.fileDeleteConfirmation && (
          <ExitConfirmation
            onCancelClick={this.removeFileCancelHandler}
            onOkayClick={this.removeFileOkayHandler}
            title="Are you sure you want to delete
            the document?"
            message=""
            buttonTitles={["No, cancel", "Yes, delete"]}
          />
        )}
      </div>
    );
  };
}
